module.exports = __webpack_public_path__ + "static/carpet-6a65812472950e5c9cbb8fcc88854cbc.png";